import React from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Accordion } from '@totalsoft/rocket-ui';
import FinancedOffersAssetItemComponent from './FinancedOffersAssetItemComponent';
import FinancedOfferItemComponentSummary from './FinancedOfferItemComponentSummary';
import PropTypes from 'prop-types';

export const FinancedOffersListItemComponent = ({
  t,
  financedOffer,
  openFinancedOffer,
  openOfferAsset,
  selectAssetsForContractGeneration,
  key
}) => {
  return (
    <Accordion
      defaultExpanded={true}
      key={key}
      title={<FinancedOfferItemComponentSummary financedOffer={financedOffer} openFinancedOffer={openFinancedOffer} />}
      content={
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('Document.ContractGeneration.Selected')}</TableCell>
                <TableCell>{t('Document.ContractGeneration.AssetName')}</TableCell>
                <TableCell>{t('Document.ContractGeneration.ChassisNumber')}</TableCell>
                <TableCell>{t('Document.ContractGeneration.PriceWithVAT')}</TableCell>
                <TableCell>{t('Document.ContractGeneration.Dealer')}</TableCell>
                <TableCell>{t('Document.ContractGeneration.ContractNumber')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {financedOffer.assets.map(asset => {
                return (
                  <FinancedOffersAssetItemComponent
                    asset={asset}
                    key={asset.id}
                    offerId={financedOffer.offerId}
                    offerSiteId={financedOffer.offerSiteId}
                    openOfferAsset={openOfferAsset}
                    selectAssetsForContractGeneration={selectAssetsForContractGeneration}
                    selected={asset.contractNumber ? false : asset.selected ? asset.selected : false}
                  />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      }
    />
  );
};

FinancedOffersListItemComponent.propTypes = {
  financedOffer: PropTypes.object.isRequired,
  openFinancedOffer: PropTypes.func.isRequired,
  openOfferAsset: PropTypes.func.isRequired,
  selectAssetsForContractGeneration: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  key: PropTypes.number
};

export default compose(withTranslation())(FinancedOffersListItemComponent);
